<div>
  <div>
    <button (click)="onDraw()">Dibujar</button>
  </div>
  <div class="map-container">
    <div class="map-frame">
      <div id="map3">
      </div>
    </div>
  </div>
</div>

